import { Component, OnInit } from "@angular/core";

@Component({
	selector: "app-multi-station-notification-maintenance",
	templateUrl: "./multi-station-notification-maintenance.component.html",
	styleUrls: ["./multi-station-notification-maintenance.component.css"],
})
export class MultiStationNotificationMaintenanceComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}

	///////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////

	ViewMode: string = "Role"; //Role | Email

	///////////////////////////////////////////////
}
